import { components } from 'react-select';
import { Box, Avatar, Flex } from '@chakra-ui/react';

export const UserOption = ({ children, data, ...props }) => {
  return (
    <components.Option {...props}>
      <Flex alignItems="center">
        <Avatar
          className="avatar-xs"
          width="20px"
          height="20px"
          name={data?.name}
          src={data?.avatar}
        />
        <Box
          as="span"
          display="inline-block"
          ml="sm"
          textTransform="captitalize"
        >
          {children}
        </Box>
      </Flex>
    </components.Option>
  );
};
